import React, { createContext, useEffect, useState } from 'react';

export const ResponsavelAluno = createContext();

export function ResponsavelAlunoProvider({ children }) {
    const [alunos, setAlunos] = useState([]);

    const carregarAlunos = async () => {
        const API_URL = process.env.REACT_APP_API_URL;
        const id_responsavel = localStorage.getItem("id_responsavel")

        if (!id_responsavel) return

        try{
            console.log("Buscando alunos do responsável")
            const url = `${API_URL}/buscaralunosresponsavel/${id_responsavel}`;
            const response = await fetch(url)
            const data = await response.json()
            setAlunos(data)
        }
        catch(error){
            console.log("erro", error)
        }
    }

    useEffect(() =>{
        carregarAlunos()
    }, [])

    return(
        <ResponsavelAluno.Provider value={{alunos, setAlunos, carregarAlunos}}>
            {children}
        </ResponsavelAluno.Provider>
    )
}
